import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Button, Grid, Typography, Divider } from "@material-ui/core";
import { ProfileType } from "../../types/enum.js";
import { hasMyobPlanAccess } from "../../helper/billingAccess";
import ConfirmationModal from "../../components/modal/ConfirmationModal.js";
import ConfirmationModalCheckboxBasic from "../../components/modal/ConfirmationModalCheckboxBasic.js";
import Select from "react-select";

import XeroIcon from "../../img/xero_logo.png";
import MyobIcon from "../../img/myob_logo.png";
import QuickBooksIcon from "../../img/quickbooks_logo.png";

import "./AccountSetting.css";

const MYOB_KEY = process.env.REACT_APP_MYOB_KEY;
const MYOB_REDIRECT_URL = process.env.REACT_APP_MYOB_REDIRECT_URL;
const XERO_KEY = process.env.REACT_APP_XERO_CLIENT_ID;
const XERO_REDIRECT_URL = process.env.REACT_APP_XERO_REDIRECT_URI;
const ENABLE_MYOB = process.env.REACT_APP_ENABLE_MYOB === "true";
const ENABLE_XERO = process.env.REACT_APP_ENABLE_XERO === "true";
const ENABLE_SUBSCRIPTION = process.env.REACT_APP_ENABLE_SUBSCRIPTION === "true";

const XERO_AUTH_URL = `https://login.xero.com/identity/connect/authorize?response_type=code&client_id=${XERO_KEY}&redirect_uri=${XERO_REDIRECT_URL}&scope=offline_access openid profile email accounting.settings accounting.transactions accounting.contacts accounting.attachments payroll.employees payroll.payslip payroll.settings payroll.payruns&state=123`;

@inject("profileStore", "hgBillingStore", "xeroStore", "myobStore", "userStore", "templateStore")
@withRouter
@observer
class IntegrationCardsGrid extends Component {
    state = {
        xeroActive: false,
        xeroTenantName: "",
        showStep3Xero: false,
        selectTenantPhase: false,
        selectedXeroTenant: "",
        selectedXeroOptions: [],
        showXeroDisconnectModal: false,
        openFirstConfirmationXeroDialog: false,
        xeroReset: false,

        myobActive: false,
        myobAccountName: "",
        showStep3Myob: false,
        selectCompanyPhase: false,
        selectedMYOBCompany: "",
        selectedMYOBOptions: [],
        showMyobDisconnectModal: false
    };

    componentDidMount() {
        this.syncIntegrationState();
    }

    componentDidUpdate(prevProps) {
        const prevProfile = prevProps.profileStore.getCurrentProfile();
        const currentProfile = this.props.profileStore.getCurrentProfile();
        if (prevProfile?.activateXeroAccess !== currentProfile?.activateXeroAccess ||
            prevProfile?.activateMYOBAccess !== currentProfile?.activateMYOBAccess ||
            prevProfile?.xeroTenantId !== currentProfile?.xeroTenantId ||
            prevProfile?.myobCompanyUri !== currentProfile?.myobCompanyUri) {
            this.syncIntegrationState();
        }
    }

    hasIntegrationAccess() {
        const currentProfile = this.props.profileStore.getCurrentProfile();
        const { billingAccess } = this.props.hgBillingStore;
        return hasMyobPlanAccess(currentProfile, billingAccess);
    }

    syncIntegrationState() {
        let currentProfile = this.props.profileStore.getCurrentProfile();
        if (!currentProfile?.hasOrganisation || currentProfile?.isOwnOrganization) {
        } else {
            currentProfile = currentProfile?.organisationOwner;
        }

        if (currentProfile && currentProfile?.activateXeroAccess && this.hasIntegrationAccess()) {
            if (!currentProfile?.xeroTenantId) {
                this.props.xeroStore.getXeroTenantId(currentProfile?.id).then(result => {
                    this.setState({
                        selectTenantPhase: true,
                        selectedXeroOptions: this.props.xeroStore.tenantList,
                        selectedXeroTenant: currentProfile?.xeroTenantId,
                        xeroActive: true,
                        xeroTenantName: currentProfile?.xeroTenantName,
                        showStep3Xero: true
                    });
                });
            } else {
                var options = [];
                options.push({ value: currentProfile?.xeroTenantId, label: currentProfile?.xeroTenantName });
                this.setState({
                    selectTenantPhase: false,
                    selectedXeroOptions: options,
                    selectedXeroTenant: currentProfile?.xeroTenantId,
                    xeroActive: true,
                    xeroTenantName: currentProfile?.xeroTenantName,
                    showStep3Xero: true
                });
            }
        } else {
            this.setState({
                xeroActive: false,
                xeroTenantName: "",
                showStep3Xero: false
            });
        }

        if (currentProfile && currentProfile?.activateMYOBAccess && this.hasIntegrationAccess()) {
            if (!currentProfile?.myobCompanyUri) {
                this.props.myobStore.getMYOBListCompany(currentProfile?.id).then(result => {
                    this.setState({
                        selectCompanyPhase: true,
                        selectedMYOBOptions: this.props.myobStore.companyUrl,
                        selectedMYOBCompany: currentProfile?.myobCompanyUri,
                        myobActive: true,
                        myobAccountName: currentProfile?.myobCompanyName,
                        showStep3Myob: true
                    });
                });
            } else {
                var myobOptions = [];
                myobOptions.push({ value: currentProfile?.myobCompanyUri, label: currentProfile?.myobCompanyName });
                this.setState({
                    selectCompanyPhase: false,
                    selectedMYOBOptions: myobOptions,
                    selectedMYOBCompany: currentProfile?.myobCompanyUri,
                    myobActive: true,
                    myobAccountName: currentProfile?.myobCompanyName,
                    showStep3Myob: true
                });
            }
        } else {
            this.setState({
                myobActive: false,
                myobAccountName: "",
                showStep3Myob: false
            });
        }
    }

    getResolvedProfile = () => {
        let currentProfile = this.props.profileStore.getCurrentProfile();
        if (!currentProfile?.hasOrganisation || currentProfile?.isOwnOrganization) {
        } else {
            currentProfile = currentProfile?.organisationOwner;
        }
        return currentProfile;
    };

    handleConnectXero = () => {
        window.location.href = XERO_AUTH_URL;
    };

    handleOpenFirstXeroModal = () => this.setState({ openFirstConfirmationXeroDialog: true, xeroReset: false });
    handleCloseFirstXeroModal = () => this.setState({ openFirstConfirmationXeroDialog: false, xeroReset: false });

    handleDisconnectXeroOpt1 = (checked) => {
        this.handleOpenXeroModal(checked);
    };

    handleOpenXeroModal = (xeroReset) => this.setState({ showXeroDisconnectModal: true, xeroReset: xeroReset, openFirstConfirmationXeroDialog: false });
    handleCloseXeroModal = () => this.setState({ showXeroDisconnectModal: false, xeroReset: false });

    handleDisconnectXero = () => {
        const currentProfile = this.getResolvedProfile();
        this.props.templateStore.showLoadingScreen();
        this.props.xeroStore.disconnect(currentProfile?.id, this.state.xeroReset).finally(() => {
            this.props.profileStore.loadProfiles().finally(() => {
                this.props.templateStore.hideLoadingScreen();
                this.setState({
                    showXeroDisconnectModal: false,
                    showStep3Xero: false,
                    xeroActive: false
                });
            });
        });
    };

    handleChangeXeroTenant = (selectedOption) => {
        this.setState({ selectedXeroTenant: selectedOption.value });
    };

    handleSelectTenant = () => {
        const { selectedXeroOptions, selectedXeroTenant } = this.state;
        this.props.handleLoading(true);
        const currentProfile = this.getResolvedProfile();
        var selectedOptions = selectedXeroOptions.filter(x => x.value === selectedXeroTenant)[0];
        this.props.xeroStore
            .handleSelectTenant({ profileId: currentProfile?.id, xeroTenantId: selectedOptions.value, xeroTenantName: selectedOptions.label })
            .finally(response => {
                this.props.profileStore.loadProfiles().finally(() => {
                    this.props.handleLoading(false);
                    this.setState({
                        selectTenantPhase: false,
                        selectedXeroOptions: [selectedOptions],
                        selectedXeroTenant: selectedOptions.value
                    });
                });
            });
    };

    handleConnectMyob = () => {
        const { currentUser } = this.props.userStore;
        const authUrl = `https://secure.myob.com/oauth2/account/authorize?client_id=${MYOB_KEY}&redirect_uri=${MYOB_REDIRECT_URL}&response_type=code&scope=CompanyFile la.global&state=${currentUser?.id}`;
        window.location.href = authUrl;
    };

    handleOpenMYOBModal = () => this.setState({ showMyobDisconnectModal: true });
    handleCloseMYOBModal = () => this.setState({ showMyobDisconnectModal: false });

    handleDisconnectMyob = () => {
        const currentProfile = this.getResolvedProfile();
        this.props.handleLoading(true);
        this.props.myobStore.disconnect(currentProfile?.id).finally(() => {
            this.props.profileStore.loadProfiles().finally(() => {
                this.props.handleLoading(false);
                this.setState({
                    showMyobDisconnectModal: false,
                    showStep3Myob: false,
                    myobActive: false
                });
            });
        });
    };

    handleChangeMYOBCompany = (selectedOption) => {
        this.setState({ selectedMYOBCompany: selectedOption.value });
    };

    handleSelectCompany = () => {
        const { selectedMYOBOptions, selectedMYOBCompany } = this.state;
        this.props.handleLoading(true);
        const currentProfile = this.getResolvedProfile();
        var selectedOptions = selectedMYOBOptions.filter(x => x.value === selectedMYOBCompany)[0];
        this.props.myobStore
            .handleSelectCompany({ profileId: currentProfile?.id, myobCompanyUri: selectedOptions.value, myobCompanyName: selectedOptions.label })
            .finally(response => {
                this.props.profileStore.loadProfiles().finally(() => {
                    this.props.handleLoading(false);
                    this.setState({
                        selectCompanyPhase: false,
                        selectedMYOBOptions: [selectedOptions],
                        selectedMYOBCompany: selectedOptions.value
                    });
                });
            });
    };

    renderXeroSetupSteps() {
        const { xeroActive, showStep3Xero, selectTenantPhase, selectedXeroOptions, selectedXeroTenant } = this.state;
        let hasSubscribe = !ENABLE_SUBSCRIPTION ? true : false;

        if (!showStep3Xero) return null;

        return (
            <div className="as-integration-setup">
                <Divider style={{ margin: "16px 0" }} />
                <div className="as-setup-step">
                    <div className="as-setup-step-header">
                        <span className="as-setup-step-number">1</span>
                        <div>
                            <Typography variant="subtitle2">Connect Hot Giggity to your Xero account</Typography>
                            {xeroActive ?
                                <Typography style={{ color: "#4caf50", fontSize: "0.75rem" }}>Successfully connected</Typography> :
                                <Typography style={{ color: "#999", fontSize: "0.75rem" }}>Xero not connected</Typography>
                            }
                        </div>
                    </div>
                    <div className="as-setup-step-actions">
                        {xeroActive ? (
                            <Fragment>
                                <Button variant="outlined" size="small" onClick={this.handleOpenFirstXeroModal}>
                                    Disconnect
                                </Button>
                                <Button
                                    variant="contained" size="small" color="secondary"
                                    target="_blank"
                                    href={XERO_AUTH_URL}
                                    disabled={!hasSubscribe}
                                    style={{ marginLeft: 8 }}
                                >
                                    Reconnect
                                </Button>
                            </Fragment>
                        ) : (
                            <Button
                                variant="contained" size="small" color="primary"
                                target="_blank"
                                href={XERO_AUTH_URL}
                                disabled={!hasSubscribe}
                            >
                                Connect Xero
                            </Button>
                        )}
                    </div>
                </div>

                <Divider style={{ margin: "12px 0" }} />

                <div className="as-setup-step">
                    <div className="as-setup-step-header">
                        <span className="as-setup-step-number">2</span>
                        <div style={{ flex: 1 }}>
                            <Typography variant="subtitle2">Select Tenant Profile</Typography>
                            <div style={{ marginTop: 8 }}>
                                <Select
                                    value={selectedXeroTenant}
                                    onChange={this.handleChangeXeroTenant}
                                    options={selectedXeroOptions}
                                    isDisabled={!selectTenantPhase}
                                />
                            </div>
                        </div>
                    </div>
                    {selectTenantPhase && (
                        <div className="as-setup-step-actions">
                            <Button variant="contained" size="small" color="primary" onClick={this.handleSelectTenant}>
                                Connect Account
                            </Button>
                        </div>
                    )}
                </div>

                {!selectTenantPhase && (
                    <Fragment>
                        <Divider style={{ margin: "12px 0" }} />
                        <div className="as-setup-step">
                            <div className="as-setup-step-header">
                                <span className="as-setup-step-number">3</span>
                                <div>
                                    <Typography variant="subtitle2">Complete your Xero setup</Typography>
                                    <Typography style={{ color: "#999", fontSize: "0.75rem" }}>You must complete the setup process to use this feature</Typography>
                                </div>
                            </div>
                            <div className="as-setup-step-actions">
                                <Button variant="contained" size="small" color="primary" onClick={() => this.props.history.push("/XEROSetting")}>
                                    Manage Xero
                                </Button>
                            </div>
                        </div>
                    </Fragment>
                )}
            </div>
        );
    }

    renderMyobSetupSteps() {
        const { myobActive, showStep3Myob, selectCompanyPhase, selectedMYOBOptions, selectedMYOBCompany } = this.state;
        const { currentUser } = this.props.userStore;
        let hasSubscribe = !ENABLE_SUBSCRIPTION ? true : false;

        if (!myobActive && !showStep3Myob) return null;

        return (
            <div className="as-integration-setup">
                <Divider style={{ margin: "16px 0" }} />
                <div className="as-setup-step">
                    <div className="as-setup-step-header">
                        <span className="as-setup-step-number">1</span>
                        <div>
                            <Typography variant="subtitle2">Connect Hot Giggity to your MYOB account</Typography>
                            {myobActive ?
                                <Typography style={{ color: "#4caf50", fontSize: "0.75rem" }}>Successfully connected</Typography> :
                                <Typography style={{ color: "#999", fontSize: "0.75rem" }}>MYOB not connected</Typography>
                            }
                        </div>
                    </div>
                    <div className="as-setup-step-actions">
                        {myobActive ? (
                            <Button variant="outlined" size="small" onClick={this.handleOpenMYOBModal}>
                                Disconnect
                            </Button>
                        ) : (
                            <Button
                                variant="contained" size="small" color="primary"
                                target="_blank"
                                href={`https://secure.myob.com/oauth2/account/authorize?client_id=${MYOB_KEY}&redirect_uri=${MYOB_REDIRECT_URL}&response_type=code&scope=CompanyFile la.global&state=${currentUser?.id}`}
                                disabled={!hasSubscribe}
                            >
                                Connect MYOB
                            </Button>
                        )}
                    </div>
                </div>

                <Divider style={{ margin: "12px 0" }} />

                <div className="as-setup-step">
                    <div className="as-setup-step-header">
                        <span className="as-setup-step-number">2</span>
                        <div style={{ flex: 1 }}>
                            <Typography variant="subtitle2">Select Company Profile</Typography>
                            <div style={{ marginTop: 8 }}>
                                <Select
                                    value={selectedMYOBCompany}
                                    onChange={this.handleChangeMYOBCompany}
                                    options={selectedMYOBOptions}
                                    isDisabled={!selectCompanyPhase}
                                />
                            </div>
                        </div>
                    </div>
                    {selectCompanyPhase && (
                        <div className="as-setup-step-actions">
                            <Button variant="contained" size="small" color="primary" onClick={this.handleSelectCompany}>
                                Connect Account
                            </Button>
                        </div>
                    )}
                </div>

                {!selectCompanyPhase && myobActive && (
                    <Fragment>
                        <Divider style={{ margin: "12px 0" }} />
                        <div className="as-setup-step">
                            <div className="as-setup-step-header">
                                <span className="as-setup-step-number">3</span>
                                <div>
                                    <Typography variant="subtitle2">Complete your MYOB setup</Typography>
                                    <Typography style={{ color: "#999", fontSize: "0.75rem" }}>You must complete the setup process to use this feature</Typography>
                                </div>
                            </div>
                            <div className="as-setup-step-actions">
                                <Button variant="contained" size="small" color="primary" onClick={() => this.props.history.push("/myobSetting")}>
                                    Manage MYOB
                                </Button>
                            </div>
                        </div>
                    </Fragment>
                )}
            </div>
        );
    }

    render() {
        const { currentProfile } = this.props.profileStore;
        const { billingAccess } = this.props.hgBillingStore;
        const { currentUser } = this.props.userStore;
        const hasIntegrationAccess = this.hasIntegrationAccess();
        const { xeroActive, myobActive } = this.state;
        let hasSubscribe = !ENABLE_SUBSCRIPTION ? true : false;

        let profile = currentProfile;
        if (!profile?.hasOrganisation || profile?.isOwnOrganization) {
        } else {
            profile = profile?.organisationOwner;
        }

        const isXeroConnected = profile?.activateXeroAccess;
        const isMyobConnected = profile?.activateMYOBAccess;

        const isOrganisationOwner = currentProfile?.isOwnOrganization;
        const hasOrganisation = currentProfile?.hasOrganisation;
        const isConsultant = currentProfile?.isConsultant;
        const profileType = currentProfile?.type;

        const canAccessXeroMyob = (profileType !== ProfileType.Staff.ordinal) ||
            (profileType === ProfileType.Staff.ordinal && (!hasOrganisation || currentProfile?.allowInvoices));

        const showXero = ENABLE_XERO && (
            (profileType === ProfileType.Agent.ordinal && !isConsultant) ||
            (profileType !== ProfileType.Agent.ordinal && !isMyobConnected && canAccessXeroMyob)
        );

        const showMyob = ENABLE_MYOB && !isXeroConnected && (
            (profileType === ProfileType.Agent.ordinal && !isConsultant) ||
            (profileType !== ProfileType.Agent.ordinal && canAccessXeroMyob)
        );

        if (!ENABLE_MYOB && !ENABLE_XERO) {
            return (
                <div style={{ textAlign: "center", padding: "40px 20px", fontSize: "1.1rem" }}>
                    Coming soon
                </div>
            );
        }

        if (!hasIntegrationAccess) {
            return (
                <div style={{ textAlign: "center", padding: "40px 20px" }}>
                    <p style={{ fontSize: "1.1rem", marginBottom: 16 }}>
                        Integrations are only available with the Pro plan
                    </p>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.props.redirectMembership}
                    >
                        Upgrade to Access
                    </Button>
                </div>
            );
        }

        if (!showXero && !showMyob) {
            if (profileType === ProfileType.Agent.ordinal && isConsultant) {
                return (
                    <div style={{ textAlign: "center", padding: "40px 20px", fontSize: "1.1rem" }}>
                        Pro integrations are only available to the agency owner.
                    </div>
                );
            }
            if (profileType === ProfileType.Staff.ordinal && hasOrganisation && !isOrganisationOwner && !currentProfile?.allowInvoices) {
                return (
                    <div style={{ textAlign: "center", padding: "40px 20px", fontSize: "1.1rem" }}>
                        Pro integrations are only accessible by the venue account owner.
                    </div>
                );
            }
        }

        return (
            <Fragment>
                <div className="as-integration-grid">
                    {showXero && (
                        <div className={`as-integration-card ${isXeroConnected ? 'as-card-expanded' : ''}`}>
                            <div className="as-integration-card-header">
                                <img src={XeroIcon} alt="Xero" className="as-integration-card-logo" />
                                <span className="as-integration-card-name">Xero</span>
                            </div>
                            <p className="as-integration-card-desc">
                                Automatically sync invoices and payments with your Xero account.
                            </p>
                            <div className="as-integration-card-footer">
                                <div className="as-integration-status">
                                    <span className={`as-status-dot ${isXeroConnected ? 'connected' : 'disconnected'}`}></span>
                                    <span className={`as-status-text ${isXeroConnected ? 'connected' : 'disconnected'}`}>
                                        {isXeroConnected ? 'Connected' : 'Not Connected'}
                                    </span>
                                </div>
                                {isXeroConnected ? (
                                    <Fragment>
                                        <div style={{ display: "flex", gap: 8 }}>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                onClick={this.handleOpenFirstXeroModal}
                                            >
                                                Disconnect
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                size="small"
                                                target="_blank"
                                                href={XERO_AUTH_URL}
                                                disabled={!hasSubscribe}
                                            >
                                                Reconnect
                                            </Button>
                                        </div>
                                    </Fragment>
                                ) : (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        target="_blank"
                                        href={XERO_AUTH_URL}
                                        disabled={!!isMyobConnected || !hasSubscribe}
                                    >
                                        Connect
                                    </Button>
                                )}
                            </div>
                            {this.renderXeroSetupSteps()}
                        </div>
                    )}

                    {showMyob && (
                        <div className={`as-integration-card ${isMyobConnected ? 'as-card-expanded' : ''}`}>
                            <div className="as-integration-card-header">
                                <img src={MyobIcon} alt="MYOB" className="as-integration-card-logo" />
                                <span className="as-integration-card-name">MYOB</span>
                            </div>
                            <p className="as-integration-card-desc">
                                Connect to MYOB for seamless accounting integration.
                            </p>
                            <div className="as-integration-card-footer">
                                <div className="as-integration-status">
                                    <span className={`as-status-dot ${isMyobConnected ? 'connected' : 'disconnected'}`}></span>
                                    <span className={`as-status-text ${isMyobConnected ? 'connected' : 'disconnected'}`}>
                                        {isMyobConnected ? 'Connected' : 'Not Connected'}
                                    </span>
                                </div>
                                {isMyobConnected ? (
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={this.handleOpenMYOBModal}
                                    >
                                        Disconnect
                                    </Button>
                                ) : (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        onClick={this.handleConnectMyob}
                                        disabled={!!isXeroConnected || !hasSubscribe}
                                    >
                                        Connect
                                    </Button>
                                )}
                            </div>
                            {this.renderMyobSetupSteps()}
                        </div>
                    )}

                    <div className="as-integration-card disabled">
                        <div className="as-integration-card-header">
                            <img src={QuickBooksIcon} alt="QuickBooks" className="as-integration-card-logo qb-logo" />
                            <span className="as-integration-card-name">QuickBooks</span>
                            <span className="as-coming-soon-badge">Coming Soon</span>
                        </div>
                        <p className="as-integration-card-desc">
                            Integrate with QuickBooks for accounting and invoicing.
                        </p>
                        <div className="as-integration-card-footer">
                            <div className="as-integration-status">
                                <span className="as-status-dot disconnected"></span>
                                <span className="as-status-text disconnected">Not Connected</span>
                            </div>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                disabled
                            >
                                Connect
                            </Button>
                        </div>
                    </div>
                </div>

                <ConfirmationModalCheckboxBasic
                    open={this.state.openFirstConfirmationXeroDialog}
                    title="Disconnect Xero Connection"
                    message="You're about to disconnect your Xero account from Hot Giggity. This will stop all future synchronisation between the two platforms. "
                    closeHandler={this.handleCloseFirstXeroModal}
                    declineHandler={this.handleCloseFirstXeroModal}
                    confirmationHandler={this.handleDisconnectXeroOpt1}
                    confirmationLabel="Disconnect Xero"
                    declineLabel="Cancel"
                    maxWidth="sm"
                />

                <ConfirmationModal
                    open={this.state.showXeroDisconnectModal}
                    title="Are you sure you want to disconnect your Xero account?"
                    message={this.state.xeroReset ? `By disconnecting your account, you will no longer be able to sync your customer invoices and supplier bills between Hot Giggity and Xero. </br>
                    You have also chosen to delete synchronisation data - this cannot be undone. </br>
                    Do you want to continue?` : `By disconnecting your account, you will no longer be able to sync your customer invoices and supplier bills between Hot Giggity and Xero. </br>
                    Do you want to continue?`}
                    closeHandler={this.handleCloseXeroModal}
                    confirmationHandler={this.handleDisconnectXero}
                    declineHandler={this.handleCloseXeroModal}
                    confirmationLabel="Disconnect"
                    declineLabel="Cancel"
                    maxWidth="sm"
                />

                <ConfirmationModal
                    open={this.state.showMyobDisconnectModal}
                    title="Are you sure you want to disconnect your MYOB account?"
                    message="By disconnecting your account, you will no longer be able to sync your customer invoices and supplier bills between Hot Giggity and MYOB. </br>
                    The synchronisation data in Hot Giggity will also be deleted. </br>
                    Do you want to continue?"
                    closeHandler={this.handleCloseMYOBModal}
                    confirmationHandler={this.handleDisconnectMyob}
                    declineHandler={this.handleCloseMYOBModal}
                    confirmationLabel="Disconnect"
                    declineLabel="Cancel"
                    maxWidth="sm"
                />
            </Fragment>
        );
    }
}

export default IntegrationCardsGrid;
